import { PtLuxonDate } from '../projects/date.models';

export class VesselCrewOvertimeEditor {
  id: number | null;
  name: string;
  description: string;
  function: string;
  hours: number;
  requestedBy: string;
}


export class VesselCrewEditor {
  id: number | null;
  localId: number;
  date: PtLuxonDate;
  isCompleted: boolean;
  usePobStructure: boolean;
  pobSwitchDate: PtLuxonDate;
  numberOfFlights: number;
  numberOfCrewBoats: number;
  personnelOn: number;
  personnelOff: number;
  seajacksPersonnel: number;
  isPreviousSeajacksPersonnel: boolean;
  cadelerContractors: number;
  cateringPersonnel: number;
  isPreviousCateringPersonnel: boolean;
  clientPersonnel: number;
  isPreviousClientPersonnel: boolean;
  otherPersonnel: number;
  isPreviousOtherPersonnel: boolean;
  totalPob: number;
  crewChangeMeals: number;
  dayVisitorsMeals: number;
  contractorsMeals: number;
  pilotMeals: number;
  overtime: VesselCrewOvertimeEditor[];
}



// WEBPACK FOOTER //
// ./src/models/vessel-crew/vessel-crew.models.ts